import { ButtonBase } from '../button-base';
import { MenuItemProps } from './menu-item-props';
import { MenuItemText } from '../menu-item-text';
import React from 'react';
import { cx } from '@mint/core';
import styled from 'styled-components';

/**
 * List root class name.
 */
const ROOT_CLASS_NAME = 'menu-item';

/**
 * Component to use.
 */
const DEFAULT_COMPONENT = 'li';

/**
 * List component implementation before styling.
 */
export const MenuItemComponent = React.forwardRef<any, MenuItemProps>(
  (props, ref): React.ReactElement => {
    const {
      children,
      className,
      color,
      component: Component = DEFAULT_COMPONENT,
      ...rest
    } = props;

    const componentProps = {
      className: cx(ROOT_CLASS_NAME, className),
      ...rest,
      ref,
    };

    return (
      <ButtonBase role="menuitem" component={Component} {...componentProps}>
        {children}
      </ButtonBase>
    );
  },
);

MenuItemComponent.displayName = 'MenuItem';

export const MenuItem = styled(MenuItemComponent)`
  display: flex;
  padding: ${(props): string => props.theme.ms(-3, 0, 'em')};

  ${MenuItemText} {
    flex: 1;
  }
`;
